import { VALUE_STATEMENT, VALUE_PROPS } from "#/lib/constants";
import { Icon } from "#/components/shared/Icon";
import { useScrollAnimation } from "#/hooks/useScrollAnimation";

/**
 * Section 2 — full-flame "value" band that flows straight out of the hero's
 * flame bottom band. Layout mirrored from the client's "Rooflet" reference
 * (full-accent background, centered bold statement, 3 icon feature cards).
 * Only the palette differs: reference red -> flame; the darker-red cards -> a
 * darker graphite tint of the flame band.
 */
export function ValueProps() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section id="value" className="bg-flame">
      <div className="mx-auto max-w-6xl px-6 pt-16 pb-20 md:pt-20 md:pb-28 lg:pt-56 lg:pb-32">
        {/* Centered statement */}
        <h2
          ref={ref}
          className={`mx-auto max-w-4xl text-center font-heading text-3xl font-bold leading-[1.15] text-white transition-all duration-700 sm:text-4xl lg:text-5xl ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
          }`}
        >
          {VALUE_STATEMENT}
        </h2>

        {/* 3 feature cards */}
        <div className="mt-14 grid gap-5 md:mt-20 md:grid-cols-3">
          {VALUE_PROPS.map((p, i) => (
            <div
              key={p.title}
              className={`rounded-lg bg-graphite/20 p-7 ring-1 ring-white/10 transition-all duration-700 hover:bg-graphite/30 lg:p-8 ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
              }`}
              style={{ transitionDelay: `${150 + i * 120}ms` }}
            >
              <Icon name={p.icon} className="h-10 w-10 text-white" />
              <h3 className="mt-6 font-heading text-lg font-bold text-white lg:text-xl">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-white/85">
                {p.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
